import { Checkbox } from "antd";
import classNames from "classnames";
import styles from "./index.module.less";
/**
 *  @param {*} props
 *
 */
export default function FilterCheckbox({
  className = "",
  name = "",
  value,
  onChange,
  ...props
}) {
  const onValueChange = (evt) => {
    onChange && onChange(evt.target.checked);
  };

  return (
    <label
      className={classNames([
        styles.container,
        value ? styles.active : null,
        className,
      ])}
    >
      <div className={styles.text}>{name}</div>
      <div className={styles.checkbox}>
        <Checkbox checked={value} onChange={onValueChange} {...props} />
      </div>
    </label>
  );
}
